import {
  QREditorModalDataProps,
  QREditorModuleTranslationsProps,
} from "@/templates/QrEditorTemplates/qr-layout/types";
import { QREditorSelectorPreviewSelectorDataProps } from "@/templates/QrEditorTemplates/qr-selector/types";

export interface QRPreviewProps {
  previewHome?: QREditorSelectorPreviewSelectorDataProps;
  previewType?: "data" | "qr" | undefined;
  previewTranslations?: any;
  previewButtonsTranslations?: QREditorModuleTranslationsProps;
  isQRInit?: boolean;
  data?: any;
  isModal?: boolean;
  isQRActivated?: boolean;
  language?: string;
  modalData?: QREditorModalDataProps;
  defaultPreviewTitle?: string;
}
export const PreviewSource = {
  editor: "editor",
  previewPage: "preview-page",
};
